import { processDownload } from '@pba/utils';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { mediaExport } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Media cannot be exported, please try again later.');
};

export type MediaExportParams = {
  fileName?: string;
  ids: string[];
};

export const useExportMedia = () =>
  useMutation<Blob, MediaExportParams>({
    defaultMutateOnError,
    async mutationFn({ ids }) {
      const { data } = await mediaExport({
        body: { ids },
      });

      return data;
    },
    onSuccess(data, variables) {
      processDownload({ data, fileName: variables.fileName ?? 'Attachments.zip' });
    },
  });
